import { supabase } from './supabaseClient'

// ── Client-side WhatsApp trigger — mirrors emailService.js's sendEmail:
// fire-and-forget, swallow errors as non-critical (a WhatsApp send failing
// shouldn't break the actual action — cancel/reschedule/demo-booking — it's
// attached to). POSTs to /api/send-whatsapp, the single shared endpoint for
// every immediate (non-cron) WhatsApp trigger — see src/whatsappHelper.js
// for the server-side sending logic this endpoint wraps.
export async function sendWhatsApp(templateName, to, params, { classId, recipientId } = {}) {
  if (!to) return
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const res = await fetch('/api/send-whatsapp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ accessToken: session?.access_token, templateName, to, params, classId, recipientId }),
    })
    if (!res.ok) {
      const data = await res.json().catch(() => ({}))
      console.warn('WhatsApp send failed (non-critical):', data.error || res.status)
    }
  } catch (e) {
    console.warn('WhatsApp send failed (non-critical):', e.message)
  }
}
